import { render, staticRenderFns } from "./accountBanned.vue?vue&type=template&id=b7030462&"
import script from "./accountBanned.vue?vue&type=script&lang=js&"
export * from "./accountBanned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7030462')) {
      api.createRecord('b7030462', component.options)
    } else {
      api.reload('b7030462', component.options)
    }
    module.hot.accept("./accountBanned.vue?vue&type=template&id=b7030462&", function () {
      api.rerender('b7030462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/accountBanned.vue"
export default component.exports